class EmailGameCTA extends HTMLElement {
	constructor() {
		super();
		this.elements = {
			container: this.querySelector('.email-game-cta__container'),
			email_column: this.querySelector('.email-game-cta__column--email'),
			game_column: this.querySelector('.email-game-cta__column--game'),
			klaviyo_form: this.querySelector('klaviyo-form'),
			form: this.querySelector('.email-game-cta__form'),
			button: this.querySelector('.email-game-cta__button'),
			footer_button: this.querySelector('.email-game-cta__button__footer'),
			input: this.querySelector('.email-game-cta__input'),
			modal: this.querySelector('.email-game-cta__modal'),
			modal_backdrop: this.querySelector('.email-game-cta__modal-backdrop'),
		};
	}

	connectedCallback() {
		this.checkForKlaviyoForm();
		this.attachEventListeners();
	}

	checkForKlaviyoForm() {
		const { klaviyo_form } = this.elements;

		if (klaviyo_form) {
			// Klaviyo form component handles submission, update form reference
			this.elements.form = klaviyo_form.querySelector('form');
		}
	}

	attachEventListeners() {
		const { form, klaviyo_form, footer_button, modal_backdrop, game_column } = this.elements;

		// Only attach submit handler if not using Klaviyo (which handles its own submission)
		if (form && !klaviyo_form) {
			form.addEventListener('submit', this.handleFormSubmit);
		}

		if (footer_button) {
			footer_button.addEventListener('click', this.handleFooterButtonClick.bind(this));
		}

		if (modal_backdrop) {
			modal_backdrop.addEventListener('click', this.minimizeModal.bind(this));
		}

		if (game_column) {
			game_column.addEventListener('contextmenu', this.preventContextMenu.bind(this));
			game_column.addEventListener('gm-fishing-game:exit', this.closeModal.bind(this));
		}

		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape') {
				this.closeModal();
			}
		});
	}

	handleFormSubmit() {
		// TODO: Implement form submission logic
	}

	handleFooterButtonClick() {
		this.openModal();
	}

	openModal() {
		const { modal } = this.elements;

		if (modal) {
			this.scrollY = window.scrollY;
			modal.classList.add('is-open');
			document.body.classList.add('modal-open');
			document.body.style.top = `-${this.scrollY}px`;

			const polarisWidget = document.getElementById('polaris-consent-widgets');
			if (polarisWidget) {
				polarisWidget.style.display = 'none';
			}
		}
	}

	closeModal() {
		const { modal } = this.elements;

		if (modal) {
			modal.classList.remove('is-open');
			document.body.classList.remove('modal-open');
			document.body.style.top = '';
			window.scrollTo(0, this.scrollY);

			const polarisWidget = document.getElementById('polaris-consent-widgets');
			if (polarisWidget) {
				polarisWidget.style.display = '';
			}
		}
	}

	minimizeModal() {
		const { modal, game_column } = this.elements;

		if (modal) {
			modal.classList.remove('is-open');
			document.body.classList.remove('modal-open');
			document.body.style.top = '';
			window.scrollTo(0, this.scrollY);

			const polarisWidget = document.getElementById('polaris-consent-widgets');
			if (polarisWidget) {
				polarisWidget.style.display = '';
			}
		}

		if (game_column) {
			game_column.dispatchEvent(new CustomEvent('gm-fishing-game:minimize', { bubbles: true }));
			console.log(`dispatched gm-fishing-game:minimize event`);
		}
	}

	preventContextMenu(event) {
		event.preventDefault();
		return false;
	}
}

if (!customElements.get('email-game-cta')) {
	customElements.define('email-game-cta', EmailGameCTA);
}
